
import { Typography, TextField } from '@mui/material';
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";

export default function FazerObservacoes(props) {

    return (
        <div style={{ marginBottom: 20 }}>
            <Typography style={{ lineHeight: 1.5, fontSize: 22, marginTop: 10 }} variant="h1">
                Observação
            </Typography>
            <Typography style={{ lineHeight: 1.5, fontSize: 14 }} variant="subtitle1">
                {props?.titulo}
            </Typography>

            {props.status &&
                <FormControl>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="assunto"
                        onClick={(e) => props.setMotivo(e.target.value)}
                    >
                        {(props.status === "Inactivo" || props.status === "Falecido") &&
                            <>
                                <FormControlLabel onClick={() => props.setNovoStatus('Inactivo')} value="divida" control={<Radio />} label="Divida" />
                                <FormControlLabel onClick={() => props.setNovoStatus('Falecido')} value="falecimento" control={<Radio />} label="Falecimento" />
                            </>
                        }

                        {props.status === "Suspenso" &&
                            <>
                                <FormControlLabel value="letígio" control={<Radio />} label="Letígio" />
                                <FormControlLabel value="incompatibilidade" control={<Radio />} label="Incompatibilidade com a função" />
                            </>
                        }
                    </RadioGroup>
                </FormControl>
            }
            <TextField
                // autoFocus
                id="inputObs"
                style={{ marginTop: 10, }}
                label="Descrever"
                fullWidth
                size="small"
                multiline
                minRows={3}
                name="observacao"
                variant="outlined"
                defaultValue={props.obs}
                onChange={(e) => props.setObs(e.target.value)}
            />
        </div>
    )
}